var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotaoFechar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 43.5,
    r: 36.5,
    fill: "#00D0FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 43,
    r: 33,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.616 56.015L57.0948 43.5007L69.616 31.0786C70.2435 30.3518 70.2095 29.2612 69.538 28.5754C68.8665 27.8897 67.7838 27.84 67.0532 28.4614L54.4954 40.7914L42.1573 28.3693C41.4433 27.6547 40.2902 27.6547 39.5762 28.3693C39.2296 28.7154 39.0347 29.1864 39.0347 29.6779C39.0347 30.1693 39.2296 30.6404 39.5762 30.9864L51.896 43.3901L39.3748 55.7939C39.0283 56.1399 38.8333 56.611 38.8333 57.1024C38.8333 57.5939 39.0283 58.0649 39.3748 58.411C39.7203 58.756 40.188 58.9483 40.6745 58.9455C41.1522 58.9484 41.612 58.7632 41.9559 58.4294L54.4954 45.9888L67.0532 58.6322C67.3986 58.9772 67.8663 59.1695 68.3529 59.1666C68.8331 59.1646 69.2933 58.9727 69.6343 58.6322C69.9784 58.2836 70.1701 57.8112 70.1666 57.3198C70.1632 56.8283 69.965 56.3586 69.616 56.015Z",
    fill: "#00D0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotaoFechar);
export default __webpack_public_path__ + "static/media/botao-fechar.0f6ae4b8b426118cef79166e49e29603.svg";
export { ForwardRef as ReactComponent };